import {CtxOrReq} from 'next-auth/client/_utils'
import {getSession} from 'next-auth/react'

/**
 * next-auth >= 4.22 turns getSession() into a POST to /api/auth/session whenever the request it is
 * handed carries a body. That route is the CSRF gated session update endpoint, so it answers 400 and
 * the session comes back as null - which silently unauthenticates every API route reading the
 * session while handling a POST/PUT/PATCH. Forwarding only the cookie keeps the call a GET.
 */
export const getRequestSession = async (ctxOrReq?: CtxOrReq) => {
  const req = ctxOrReq?.req ?? ctxOrReq?.ctx?.req

  if (!req) {
    return await getSession()
  }

  return await getSession({req: {headers: {cookie: req.headers?.cookie}}})
}
